"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERENCE_SUMMARY_COPY = void 0;
exports.REFERENCE_SUMMARY_COPY = {
    APEX_CLASSES: 'Apex Classes',
    APEX_TRIGGERS: 'Apex Triggers',
    CHART_HEADER: 'Standard Object Reference Summary',
    FLOWS: 'Flows',
    FORMULA_FIELDS: 'Formula Fields',
    LOOKUP_FIELDS: 'Lookup Fields',
    PROCESS_BUILDERS: 'Process Builders',
    REFERENCE_COUNT: 'Reference Count',
    VALIDATION_RULES: 'Validation Rules',
    WORKFLOW_RULES: 'Workflow Rules'
};
//# sourceMappingURL=REFERENCE_SUMMARY_COPY.js.map